<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/08_Fm02"><i>Polish Publisher’s Note</i></a></p>
<p class="toc"><a href="#/xhtml/09_Acknowledgement"><i>Acknowledgments</i></a></p>
<p class="toct"><a href="#/xhtml/10_Chapter01">Prologue</a></p>
<p class="toc"><a href="#/xhtml/11_Chapter02">Oświęcim</a></p>
<p class="toc"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">Kraków</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">Wieliczka</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">Tarnów</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">Bochnia</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">Bergen-Belsen</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">Tröbitz</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter09" title="Link target outside of Sample">Return to Oświęcim</span></p>
<p class="toct"><span href="#/xhtml/19_Appendix01" title="Link target outside of Sample"><i>Appendix</i></span></p>
<p class="toc"><span href="#/xhtml/20_Index01" title="Link target outside of Sample"><i>Index of Names</i></span></p>
<p class="toc"><span href="#/xhtml/21_Index02" title="Link target outside of Sample"><i>Index of Place Names</i></span></p>
<p class="toct"><span href="#/xhtml/14_Chapter05#ill1" title="Link target outside of Sample"><i>Illustrations</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?2fc4764f